// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"DE-z","smallCardRow":"EE-z","largeCardRow":"FE-z","productSearchRow":"GE-z","curatedRow":"HE-z"};